export const looksLikeUrl = (input) => {
  // Regular expression to check if the input resembles a URL
  const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/.*)?$/;
  return urlPattern.test(input);
};
